export enum PeopleProfileMode {
  Check = 'check',
  PrintBadge = 'print-badge',
}
